import React from 'react'

import InvisibleIcon from '@components/Icon/Invisible'
import VisibleIcon from '@components/Icon/Visible'

const ToggleVisibility = ({
  invisible,
  onToggle,
  cyData = 'toggle-hide-data'
}) => (
  <span onClick={onToggle} className="toggle-visibility" data-cy={cyData}>
    {invisible ? <InvisibleIcon /> : <VisibleIcon />}
  </span>
)

export default ToggleVisibility
